import { createAsyncThunk } from "@reduxjs/toolkit"
import {
  del,
  formDataPost,
  formDataPut,
  patch,
  post,
  put,
  get,
} from "helpers/api_helper"
import {
  GET_ALL_ORDERS,
  GET_ORDER_DETAILS,
  ORDER_STATUS_UPDATE,
  UPDATE_ORDER_DELIVERY_DATE,
  SYNC_ORDER_WITH_POS,
  SYNC_ORDER_WITH_SALASA,
  ASSIGN_ORDERS_TO_RIDER,
  ASSIGN_ORDERS_TO_BRANCH,
  RIDERS_FOR_ASSIGNMENT,
} from "helpers/url_helper"

export const getAllOrders = createAsyncThunk(GET_ALL_ORDERS, async payload => {
  const response = await post(GET_ALL_ORDERS, payload)
  return response
})

export const getOrderDetails = createAsyncThunk(GET_ORDER_DETAILS, async id => {
  const response = await get(`${GET_ORDER_DETAILS}/${id}`)
  return response
})

export const updateOrderStatus = createAsyncThunk(
  ORDER_STATUS_UPDATE,
  async payload => {
    const response = await patch(ORDER_STATUS_UPDATE, payload)
    return response
  }
)

export const updateOrderDeliveryDate = createAsyncThunk(
  UPDATE_ORDER_DELIVERY_DATE,
  async payload => {
    const response = await patch(UPDATE_ORDER_DELIVERY_DATE, payload)
    return response
  }
)

export const syncOrderWithPos = createAsyncThunk(
  SYNC_ORDER_WITH_POS,
  async payload => {
    const response = await post(SYNC_ORDER_WITH_POS, payload)
    return response
  }
)

export const syncOrderWithSalasa = createAsyncThunk(
  SYNC_ORDER_WITH_SALASA,
  async payload => {
    const response = await post(SYNC_ORDER_WITH_SALASA, payload)
    return response
  }
)

export const assignOrdersToRider = createAsyncThunk(
  ASSIGN_ORDERS_TO_RIDER,
  async payload => {
    const response = await patch(ASSIGN_ORDERS_TO_RIDER, payload)
    return response
  }
)

export const assignOrdersToBranch = createAsyncThunk(
  ASSIGN_ORDERS_TO_BRANCH,
  async payload => {
    const response = await patch(ASSIGN_ORDERS_TO_BRANCH, payload)
    return response
  }
)

export const getRidersForAssignment = createAsyncThunk(
  RIDERS_FOR_ASSIGNMENT,
  async payload => {
    const response = await post(RIDERS_FOR_ASSIGNMENT, payload)
    return response
  }
)
